import Logo from '../src/Logo/index';
export default Logo;
